"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var Select_1 = __importDefault(require("./Select"));
exports.Select = Select_1.default;
exports.default = Select_1.default;
//# sourceMappingURL=index.js.map